import { render, staticRenderFns } from "./Ultima.vue?vue&type=template&id=03956a00"
import script from "./Ultima.vue?vue&type=script&lang=js"
export * from "./Ultima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports